import type { ReactElement } from 'react';
import { StrictMode } from 'react';

import { Helmet, HelmetProvider } from 'react-helmet-async';
import {
  BrowserRouter as Router, Routes, Route,
} from 'react-router';

import AppVersionGuard from '@virtuslab/nfs-shared/src/components/organisms/AppVersionGuard';
import BrowserSupportGuard from '@virtuslab/nfs-shared/src/components/organisms/BrowserSupportGuard';
import ContentErrorBoundary from '@virtuslab/nfs-shared/src/components/organisms/ContentErrorBoundary';
import FeatureFlagsProvider from '@virtuslab/nfs-shared/src/components/organisms/FeatureFlagsContext';
import RenderRoutes from '@virtuslab/nfs-shared/src/components/organisms/RenderRoutes';
import SecurityProvider from '@virtuslab/nfs-shared/src/components/organisms/SecurityProvider';
import ThemeProvider from '@virtuslab/nfs-shared/src/components/organisms/ThemeProvider';
import UserPreferencesProvider from '@virtuslab/nfs-shared/src/components/organisms/UserPreferencesProvider';

import config from './config';
import { featureFlags } from './config/featureFlags';
import { LogoutRoutes } from './config/paths';
import routes from './config/routes';

import ServicesProvider from './components/organisms/ServicesProvider';

function App(): ReactElement {
  return (
    <FeatureFlagsProvider featureFlags={featureFlags}>
      <ContentErrorBoundary>
        <ThemeProvider>
          <HelmetProvider>
            <SecurityProvider
              config={config}
              redirectTo={LogoutRoutes.LOGOUT}
            >
              <StrictMode>
                <BrowserSupportGuard>
                  <AppVersionGuard config={config}>
                    <ServicesProvider>
                      <UserPreferencesProvider>
                        <Router basename={config.basePath}>
                          <Helmet titleTemplate={`%s - ${config.titleName}`} defaultTitle={config.titleName} defer />
                          <Routes>
                            <Route path="*" element={<RenderRoutes routes={routes} />} />
                          </Routes>
                        </Router>
                      </UserPreferencesProvider>
                    </ServicesProvider>
                  </AppVersionGuard>
                </BrowserSupportGuard>
              </StrictMode>
            </SecurityProvider>
          </HelmetProvider>
        </ThemeProvider>
      </ContentErrorBoundary>
    </FeatureFlagsProvider>
  );
}

export default App;
